"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var react_1 = __importDefault(require("react"));
var Modal_1 = __importDefault(require("reactstrap/lib/Modal"));
var ModalHeader_1 = __importDefault(require("reactstrap/lib/ModalHeader"));
var ModalBody_1 = __importDefault(require("reactstrap/lib/ModalBody"));
var ModalFooter_1 = __importDefault(require("reactstrap/lib/ModalFooter"));
var buttons_1 = require("../buttons");
var Modal_scss_1 = __importDefault(require("./Modal.scss"));
var classnames_1 = __importDefault(require("classnames"));
var Modal = function (props) {
    return react_1.default.createElement(Modal_1.default, { id: props.id, isOpen: props.open, toggle: props.onClose, size: props.size, onOpened: props.onOpened, keyboard: props.keyboard, backdrop: props.backdrop },
        react_1.default.createElement(ModalHeader_1.default, { className: props.className, toggle: props.onClose }, props.title),
        react_1.default.createElement(ModalBody_1.default, { className: props.className }, props.children),
        props.leftButtons || props.rightButtons ? react_1.default.createElement(ModalFooter_1.default, { className: props.className },
            props.leftButtons && props.leftButtons.map(function (r, i) { return i == props.leftButtons.length - 1 ?
                react_1.default.createElement(buttons_1.Button, __assign({ key: i }, r, { className: (0, classnames_1.default)(Modal_scss_1.default["au-modal-button-push"], r.className) })) : react_1.default.createElement(buttons_1.Button, __assign({ key: i }, r)); }),
            props.rightButtons && props.rightButtons.map(function (r, i) { return react_1.default.createElement(buttons_1.Button, __assign({ key: i }, r)); })) : react_1.default.createElement(react_1.default.Fragment, null));
};
exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map